<div class="not-found">
    <div class="not-found__container">
        <div class="not-found__icon">
            <img src="assets/logo.svg" alt="Error Icon">
        </div>
        <div class="not-found__image">
            <img src="assets/images/Laye.svg" alt="Monitor Error">
        </div>
        <h1 class="not-found__code">404</h1>
        <h2 class="not-found__title">Page not found.</h2>
        <p class="not-found__description">
            It seems we couldn’t locate the page you’re searching for. You can head back to our home page or get in touch with us if you need further assistance. We’re here to help
            you find your way!
        </p>
        <a class="not-found__button" (click)="navigateToBack()">
            <span class="not-found__button-icon"><img src="assets/icons/Home_new.svg" alt=""></span> Go to Homepage
        </a>
    </div>
</div>